import { render, staticRenderFns } from "./InfoGrid.vue?vue&type=template&id=64685965&scoped=true"
import script from "./InfoGrid.vue?vue&type=script&lang=js"
export * from "./InfoGrid.vue?vue&type=script&lang=js"
import style0 from "./InfoGrid.vue?vue&type=style&index=0&id=64685965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64685965",
  null
  
)

export default component.exports